import React from 'react';
import PropTypes from 'prop-types';
import useReferralDiscount from 'products/nomad_insurance/hooks/useReferralDiscount';
import { ReactComponent as SuccessIconSvg } from 'products/nomad_insurance/assets/img/icons/checkmark.svg';
import { CreditInfo, DiscountedPrice } from './styled';

const DiscountInfo = ({ contractTotalPrice }: { contractTotalPrice: number }) => {
  const { referralDiscount } = useReferralDiscount();

  if (referralDiscount?.applied) {
    return (
      <CreditInfo>
        <SuccessIconSvg />
        <span>
          <b>Credit applied</b> —you’ll pay{' '}
          <DiscountedPrice>${contractTotalPrice.toFixed(2)}</DiscountedPrice> for your
          first 4 weeks!
        </span>
      </CreditInfo>
    );
  }

  return null;
};

DiscountInfo.propTypes = {
  contractTotalPrice: PropTypes.number.isRequired
};

export default DiscountInfo;
